import { DateDiv } from 'DateModule/components/DateDiv';
import { DataCellProps } from '../types';

export const TenantArchivedAtCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return <DateDiv date={tenant.archivedAt} />;
};
